import React, { useEffect, useState } from "react";
import Select from "react-dropdown-select";
import { useForm, Controller } from "react-hook-form";
import { Icon, TutorialContainer } from "../../../_components";
import { createTimeUnitOptions } from "../../../_helpers";

export function DefaultTimeUnitPage({
  onSubmit,
  store,
  formRef,
  getCalendar,
  tooltipID = "",
}) {
  const [timeUnits, setTimeUnits] = useState([]);
  const [tempCalendar, setTempCalendar] = useState();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      defaultUnit: store.defaultUnit || "year",
    },
  });

  useEffect(() => {
    if (tempCalendar) {
      const options = createTimeUnitOptions(tempCalendar);
      // console.log("unit options", options);
      setTimeUnits(options);
    }
  }, [tempCalendar]);

  useEffect(() => {
    const tempCal = getCalendar();
    // console.log("TEMP CAL", tempCal, store);
    setTempCalendar(tempCal);
  }, [store]);

  return (
    <div className="chronos-default-time-page">
      <TutorialContainer
        type="video"
        url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/243f1e5e-6048-4ba3-8501-d1d4060d7f15.webm"
      />
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <div className="content-page-wrapper">
          <h2 className="chronos-wizard-page-title">
            Select Default Time Unit
          </h2>
          <p className="chronos-wizard-text">
            What unit of time should your timelines show by default?
          </p>
          {/* GIF */}

          <div className="form-group">
            <label htmlFor="defaultUnit" className="chronos-form-title">
              Default Unit of Time&nbsp;
              <Icon
                icon="fas fa-question-circle fa-fw"
                data-for={tooltipID}
                data-tip={`Tip: For a history of decades, use years. For a story/campaign unfolding over a week, use days`}
              />
            </label>
            <Controller
              control={control}
              name="defaultUnit"
              id="defaultUnit"
              render={({ value, onChange }) => {
                let defVal = timeUnits.find((o) => o.value === value);
                if (!defVal) defVal = { name: "Years", value: "year" };
                return (
                  <Select
                    options={timeUnits}
                    values={[defVal]}
                    onChange={(val) => onChange(val[0].value)}
                    dropdownGap={0}
                    labelField="name"
                    valueField="value"
                    className="chronos-select"
                  />
                );
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
